<template>
    <div class="inner-container">
        <div class="section-title budget"><span>Бюджет</span></div>
        <div class="section-subtitle">Сводные отчеты <span><budget-reports-list :curFormSelect="'/approv-report'"/></span></div>
        <b-tabs v-model="tabIndx" v-if="listReg !== null">
            <b-tab title="Баланс">
                <div class="actions-tab in-tab">
                    <b-dropdown :disabled="isDownloading" variant="link" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-item @click="downloadBalance">Сводный баланс</b-dropdown-item>
                        <b-dropdown-item v-if="selecteds_ === 1" @click="downloadBalanceDetailedReport">Развернутый баланс</b-dropdown-item>
                        <b-dropdown-item v-if="version === 0" @click="downloadSummaryReportUtilitiesAndTelecom">
                            Сводный отчёт по коммунальным<br> услугам и связи</b-dropdown-item>
                        <b-dropdown-item v-if="version === 0" 
                        @click="downloadSummaryReportCapitalExpenses">
                            Сводный отчёт по капитальным<br> затратам</b-dropdown-item>
                        <b-dropdown-item v-if="version === 0" 
                        @click="downloadSummaryReportRepair">
                            Сводный отчёт по текущему<br> ремонту</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-text>
                            <div class="info-button">
                                <span @click="infoCostForm(26)">Инструкция <i class="icon icon-folder"></i></span>
                            </div>
                            <div class="info-text">
                                <p><span class="red bold">Раздел «Сводные отчеты»</span></p>
                                <p>Данный раздел разработан как инструмент для формирования регламентированных отчётов в части доходов и расходов на стадиях Прогноз, План, Корректировка, Уточнение.</p>
                            </div>
                        </b-dropdown-text>
                    </b-dropdown>
                </div>
                <b-progress variant="success" v-show="progress<100" height="10px" :value="progress" striped
                            animated></b-progress>
                <template>
                    <balance-form ref="balanceform"
                                  :year="year"
                                  :reg="region"
                                  :data-type="dataType"
                                  @chgData="onBalanceChgData"
                                  @selectedsChanged="handleSelectedsChanged"
                    ></balance-form>
                </template>
            </b-tab>
            <b-tab title="Расходы">
                <div class="actions-tab in-tab">
                    <b-dropdown :disabled="isDownloading" variant="link" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-item @click="downloadExpenditure">Расходы</b-dropdown-item>
                        <b-dropdown-item @click="downloadExpenditures">Расходы(все отчеты)</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-text>
                            <div class="info-button">
                                <span @click="infoCostForm(26)">Инструкция <i class="icon icon-folder"></i></span>
                            </div>
                            <div class="info-text">
                                <p><span class="red bold">Раздел «Сводные отчеты»</span></p>
                                <p>Данный раздел разработан как инструмент для формирования регламентированных отчётов в части доходов и расходов на стадиях Прогноз, План, Корректировка, Уточнение.</p>
                            </div>
                        </b-dropdown-text>
                    </b-dropdown>
                </div>
                <b-progress variant="success" v-show="progress<100" height="10px" :value="progress" striped
                            animated></b-progress>
                <template>
                    <cost-reports ref="costreports"
                                  :year="year"
                                  :obl="obl"
                                  :reg="region"
                                  :variant="variant"
                                  :data-type="dataType"
                                  :list-reg="listReg"
                                  @chgData="chgData"
                    ></cost-reports>
                </template>
            </b-tab>
            <b-tab title="Доходы">
                <div class="actions-tab in-tab">
                    <b-dropdown :disabled="isDownloading" variant="link" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-item @click="downloadInExcel">Доходная часть бюджета</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-text>
                            <div class="info-button">
                                <span @click="infoCostForm(26)">Инструкция <i class="icon icon-folder"></i></span>
                            </div>
                            <div class="info-text">
                                <p><span class="red bold">Раздел «Сводные отчеты»</span></p>
                                <p>Данный раздел разработан как инструмент для формирования регламентированных отчётов в части доходов и расходов на стадиях Прогноз, План, Корректировка, Уточнение.</p>
                            </div>
                        </b-dropdown-text>
                    </b-dropdown>
                </div>
                <b-progress variant="success" v-show="progress<100" height="10px" :value="progress" striped
                            animated></b-progress>
                <template>
                    <income-form ref="incomeform"
                                 mode="report"
                                 :year="parseInt(year)"
                                 :obl="obl"
                                 :reg="region"
                                 :variant="variant"
                                 :list-reg="listReg"
                                 :data-type="dataType"
                                 :list-variants-inc="listVariantsInc"
                                 @chgData="chgData"
                    ></income-form>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from '../../../services/store';
import { Ax } from '@/utils';
import CostReports from '@/modules/budget/CostReports';
import BalanceForm from '@/modules/budget/BalanceForm';
import IncomeForm from '@/modules/budget/IncomeForm';
import BudgetReportsList from '@/modules/budget/components/budget-reports-list.vue';
import {loadVariants} from '@/modules/budget/budgetVariantService';


export default {
    name: 'ApprovForm',
    components: { CostReports, BalanceForm, IncomeForm, BudgetReportsList },
    data() {
        return {
            year: null,
            obl: null, // '45'
            region: null, // '450101',
            variant: 'f1340fa7-e90d-42a2-92ae-a6055dc1d278',
            tabIndx: 0,
            listReg: null,
            progress: 0,
            dataType: 2,
            selecteds_: 1,
            version: 0,
            balanceHeader: null, // полный фильтр «Баланса» — для отчётов вкладки «Баланс»
            selectedAbp: null,
            selectedPrg: null,
            selectedPpr: null,
            curVariant: null,
            state: null,
            user: null,
            listVariantsInc: [],
            isDownloading: false,
            curDate: null
        };
    },

    async mounted() {
        this.user = store.state.user;
        this.state = store.state;
        // this.year = CUR_YEAR.toString();
        this.year = (new Date().getFullYear()).toString();
        await this.getObl();
    },

    methods: {
        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        this.loadRegions();
                    });
                await loadVariants().then(data => {
                    this.listVariantsInc = data;
                });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },
        async loadRegions() {
            try {
                const response = await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + this.user.sub);
                if (response.status === 200) {
                    this.listReg = await response.json();
                    this.region = this.listReg[0].code;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }
        }, // справочник регионов

        // фильтр «Баланса» хранится отдельно: общий header затирают «Доходы»/«Расходы»
        // (другой вариант, нет dataType/version), а отчёты «Баланса» должны уходить с его параметрами.
        // version (АБП/УЭБП) — только отсюда: по нему показываются сводные отчёты в меню «Скачать»
        onBalanceChgData(data) {
            this.version = data.version;
            this.balanceHeader = this.buildHeader(data);
            this.chgData(data);
        },

        buildHeader(curHeader) {
            return {
                year: curHeader.year,
                curYear: curHeader.curYear,
                dataType: curHeader.dataType,
                region: curHeader.region,
                version: curHeader.version,
                variant: curHeader.variant,
                abp: curHeader.abp,
                prg: curHeader.prg,
                ppr: curHeader.ppr,
                view: curHeader.view,
                develop: curHeader.develop,
                spf: curHeader.spf,
                vzk: curHeader.vzk,
                date: curHeader.date,
                obl: this.obl,
                prog: 'false'
            };
        },

        chgData(data) {
            try {
                this.header = this.buildHeader(data);
            } catch (error) {
                this.makeToast('danger', 'Предупреждение', 'Ошибка обновления параметров ' + error.toString());
            }
        }, // обновление параметров

        infoCostForm(info_id) {
            const that = this;
            Ax(
                {
                    url: '/api-py/get-info/' + info_id, //  Тело файла
                    method: 'POST',
                    data: null,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let file = '';
                    if (info_id === 26) {
                        file = 'Инструкция Сводные отчеты';
                    }
                    link.setAttribute('download', file + '.pdf');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                }
            );
        },
        // формирование отчета
        downloadInExcel() {
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            Ax(
                {
                    url: '/api-py/in-form-download/' + that.region + '/' + that.header.variant + '/' + that.header.year + '/' + that.dataType, //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    this.progress = 45;
                    link.setAttribute('download', 'Доходная часть бюджета.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        // формирование отчета balance-agr-download
        downloadBalance() {
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            Ax(
                {
                    url: '/api-py/balance-agr-download/' + JSON.stringify(that.balanceHeader), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    this.progress = 45;
                    link.setAttribute('download', 'Сводный баланс бюджета в агрегированной форме.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        handleSelectedsChanged(selecteds) {
            this.selecteds_ = selecteds;
        },
        downloadBalanceDetailedReport() {
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            const year = new Date().getFullYear();
            const day = this.padLeadingZeros(new Date().getDate(), 2);
            const month = this.padLeadingZeros(new Date().getMonth() + 1, 2);
            this.curDate = year + '_' + month + '_' + day;
            Ax(
                {
                    url: '/api-py/balance_detailed_report_download/' +JSON.stringify(that.balanceHeader), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url =window.URL.createObjectURL(new Blob([data]));
                    const link =document.createElement('a');
                    link.href = url;
                    this.progress = 45;
                    link.setAttribute('download', 'Развернутый_баланс_' + this.curDate + '.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        downloadSummaryReportUtilitiesAndTelecom() {
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            const year = new Date().getFullYear();
            const day = this.padLeadingZeros(new Date().getDate(), 2);
            const month = this.padLeadingZeros(new Date().getMonth() + 1, 2);
            this.curDate = year + '_' + month + '_' + day;
            Ax(
                {
                    url: '/api-py/summary_report_utilities_telecom_download/' +JSON.stringify(that.balanceHeader), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url =window.URL.createObjectURL(new Blob([data]));
                    const link =document.createElement('a');
                    link.href = url;
                    this.progress = 45;
                    link.setAttribute('download', 'Форма_по_комуслугам_' + this.curDate + '.xlsx');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        padLeadingZeros(num, size) {    //
            let s = String(num);
            while (s.length < size) { s = '0' + s; }
            return s;
        },
        // формирование отчета Expenditure-download
        downloadExpenditure() {
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            Ax(
                {
                    url: '/api-py/expenditure-download/' + JSON.stringify(that.header), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    this.progress = 40;
                    link.setAttribute('download', 'Расходная часть бюджета.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        // формирование отчета Expenditures-download
        downloadExpenditures() {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            this.progress = 15;
            this.isDownloading = true;
            Ax(
                {
                    url: '/api-py/expenditures-download/' + JSON.stringify(that.header), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    this.progress = 40;
                    link.setAttribute('download', 'Расходная часть бюджета (все отчеты).xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.progress = 100;
                    this.isDownloading = false;
                },
                (error) => {
                    that.error = error;
                    this.progress = 0;
                    this.isDownloading = false;
                }
            );
        },
        async downloadSummaryReportCapitalExpenses() {
            const that = this; 
            const bf = that.$refs.balanceform;
            
            const planYear = bf?.planPeriod?.year ?? bf?.cYear ?? null;
            if (!planYear) {
                return; 
            }

            const curReg = bf?.curReg ?? null;    // live region object
            const region = curReg ? curReg.code.toString() : null;
            if (!region) {
                return; 
            }
            
            const regionType = that.getRegionType(region);
            const curVariant = bf?.curVariant ?? null;
            const variantLst = bf?.variantLst ?? [];
            const isValidRegion = (
                (["1", "2", "3"].includes(regionType) && variantLst.length > 0)
                || (["4", "5"].includes(regionType))
            ); 
            if (!isValidRegion) {
                this.makeToast(
                    'warning', 
                    this.$t('modules.summary-reports.warnings.warning'),
                    this.$t('modules.summary-reports.warnings.no-budget-variant'),
                )
                return; 
            }

            try {
                const dto = {
                    obl: that.balanceHeader?.obl,
                    region: region,
                    dataType: that.balanceHeader?.dataType,
                    year: planYear,
                    date: that.balanceHeader?.date,
                    variant: curVariant ? curVariant.variant_uuid : null,
                    vzk: that.balanceHeader?.vzk,
                    locale: that.$i18n.locale || 'ru',
                }; 
                
                this.progress = 15;
                const response = await fetch(`/api-py/summary-reports/cap-expenses-report/download/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dto),
                }); 

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                
                this.progress = 45;
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Сводный отчёт по капитальным затратам.xlsx`;
                link.style.display = 'none';
                this.progress = 100;
                link.click();
                
            } catch (error) {
                that.error = error;
                this.progress = 0;
                this.makeToast(
                    'danger',
                    this.$t('modules.summary-reports.warnings.error'),
                    this.$t('modules.summary-reports.warnings.download-error'),
                )
            }
        },
        async downloadSummaryReportRepair() {
            const that = this; 
            const bf = that.$refs.balanceform;
            
            const planYear = bf?.planPeriod?.year ?? bf?.cYear ?? null;
            if (!planYear) {
                return; 
            }

            const curReg = bf?.curReg ?? null; 
            const region = curReg ? curReg.code.toString() : null;
            if (!region) {
                return; 
            }
            
            const regionType = that.getRegionType(region);
            const curVariant = bf?.curVariant ?? null;
            const variantLst = bf?.variantLst ?? [];
            const isValidRegion = (
                (["1", "2", "3"].includes(regionType) && variantLst.length > 0)
                || (["4", "5"].includes(regionType))
            ); 
            if (!isValidRegion) {
                return; 
            }

            try {
                const dto = {
                    obl: that.balanceHeader?.obl,
                    region: region,
                    dataType: that.balanceHeader?.dataType,
                    year: planYear,
                    date: that.balanceHeader?.date,
                    variant: curVariant ? curVariant.variant_uuid : null,
                    vzk: that.balanceHeader?.vzk,
                    locale: that.$i18n.locale || 'ru',
                }; 
                
                this.progress = 15;
                const response = await fetch(`/api-py/summary-reports/repair-report/download/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dto),
                }); 

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                
                this.progress = 45;
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Сводный отчёт по текущему ремонту.xlsx`;
                link.style.display = 'none';
                this.progress = 100;
                link.click();
                
            } catch (error) {
                that.error = error;
                this.progress = 0;
                this.makeToast(
                    'danger',
                    this.$t('modules.summary-reports.warnings.error'),
                    this.$t('modules.summary-reports.warnings.download-error'),
                )
            }
        },
        getRegionType(regionCode) {
            const p1 = regionCode.slice(2, 4);
            const p2 = regionCode.slice(4, 6);

            if (p1 === "01" && p2 === "01") {
                return "1"; // Область
            } else if (!["01", "00"].includes(p1) && p2 === "01") {
                return "2"; // Район
            } else if (!["01", "00"].includes(p1) && !["01", "00"].includes(p2)) {
                return "3"; // МСУ
            } else if (p1 === "00" && p2 === "00") {
                return "4"; // Регион агрегат (область + район + МСУ)
            } else if (!["01", "00"].includes(p1) && p2 === "00") {
                return "5"; // Регион агрегат (район + МСУ)
            }
            return null; // No matching region type
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        } // сообщение
    },
    computed: {
        userId() {
            return this.$store.getters.user_uuid;
        }
    },
    watch: {
        userId: async function (newVal, oldVal) {
            if (newVal !== oldVal) {
                await this.getObl();
            }
        }
    }
};
</script>